import React from 'react';
import styled from '@emotion/styled';
import CommonSection from "../CommonSection";
import { Link as ScrollLink } from 'react-scroll';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Swiper, SwiperSlide } from 'swiper/react';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const Navigation = ({ list }) => {
  const params = {
    allowTouchMove:true,
    lazyload : {
      loadPrevNext:true
    },
    spaceBetween: 0,
    slidesPerView: 'auto'
  }

  return (
    <NavWrapper>
      <ContentWrapper>
        <Swiper {...params}>
          {list.map((item, index) => 
            <SwiperSlide key={`nav_${index}`}>
              <Item to={item.node.childMdx.frontmatter.slug} spy={true} smooth={true} offset={0} duration={500} href={`#${item.node.childMdx.frontmatter.slug}`}>
                <GatsbyImage image={getImage(item.node.childMdx.frontmatter.eyecatch)} alt={item.node.childMdx.frontmatter.title}/>
                <TitleLabel>{item.node.childMdx.frontmatter.title}</TitleLabel>
              </Item>
            </SwiperSlide>
          )}
        </Swiper>
      </ContentWrapper>
    </NavWrapper>
  );
}
 
export default Navigation;

const ContentWrapper = styled.div`
  max-width:1368px;
  margin:0 auto;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0 -12px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0 -8px;
  }
`

const NavWrapper = styled(CommonSection)`
  position:relative;
  background:none;
  

  > div{
    display:block;
    padding-top:0;
    padding-bottom:0;
    margin-top:-48px;
    text-align:center;
  }

  .swiper-slide{
    width:16.667%;
    padding:0 12px;
    box-sizing: border-box;
  }
  .swiper-container{
    overflow: visible;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .swiper-container{
      .swiper-wrapper{
        transform:none !important;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .swiper-slide{
      width:168px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    .swiper-slide{
      width:128px;
      padding:0 8px;
    }
  }
`


const Item = styled(ScrollLink)`
  position:relative;
  overflow:visible;
  display:block;

  .gatsby-image-wrapper{
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    display:block;

    box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    z-index:1;
    overflow:hidden;

    transition:transform .3s;
    
  }

  &:hover .gatsby-image-wrapper{
    transform: scale(1.15);
  }
 
`

const TitleLabel = styled.div`
  font-size: 12px;
  line-height: 24px;
  font-weight: 900;
  color: #222224;
  position:absolute;
  top:105%;
  margin-top:4px;
  left:0;
  width:100%;
  opacity:0;
  transition:opacity .3s;
  text-align:center;

  a:hover &{
    opacity:1;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 11px;
    line-height: 20px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 10px;
    line-height: 16px;
  }
`
